module.exports = __webpack_public_path__ + "static/media/straightArrow.7da0ab02.png";